module.exports = __webpack_public_path__ + "img/g.18e4c85f.jpg";